/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumReminderExternalIdSource = "awsses" | "mandrill" | "nexmo" | "plivo" | "sendgrid" | "twilio" | "%future added value";
export type EnumReminderFollowupOperation = "created" | "deleted" | "updated" | "%future added value";
export type EnumReminderStatus = "blocked" | "confirmed" | "delivered" | "emailOpened" | "failed" | "pending" | "queued" | "scheduled" | "sent" | "skipped" | "%future added value";
export type EnumReminderType = "appointment" | "feedback" | "followup" | "outboundReferral" | "patientForm" | "recall" | "referral" | "telehealth" | "waitingRoom" | "%future added value";
export type FilterFindManyReminderInput = {
    user?: string | null | undefined;
    _id?: string | null | undefined;
    deleted?: number | null | undefined;
    createdAt?: unknown | null | undefined;
    updatedAt?: unknown | null | undefined;
    createdBy?: string | null | undefined;
    updatedBy?: string | null | undefined;
    deletedBy?: string | null | undefined;
    deletedAt?: unknown | null | undefined;
    provider?: string | null | undefined;
    appointment?: string | null | undefined;
    referral?: string | null | undefined;
    recall?: string | null | undefined;
    telehealth?: string | null | undefined;
    followup?: string | null | undefined;
    followupOperation?: EnumReminderFollowupOperation | null | undefined;
    facility?: string | null | undefined;
    patient?: string | null | undefined;
    patientForm?: string | null | undefined;
    message?: unknown | null | undefined;
    type?: EnumReminderType | null | undefined;
    externalId?: ReminderExternalIdInput | null | undefined;
    sendAt?: unknown | null | undefined;
    sentAt?: unknown | null | undefined;
    contact?: Array<string | null> | null | undefined;
    messageTemplate?: string | null | undefined;
    status?: EnumReminderStatus | null | undefined;
    statusUpdatedAt?: unknown | null | undefined;
    statusReason?: string | null | undefined;
    replied?: number | null | undefined;
    repliedMessage?: string | null | undefined;
    originalRepliedMessage?: string | null | undefined;
    repliedTime?: unknown | null | undefined;
    partialStatus?: Array<unknown | null> | null | undefined;
    forcedTime?: boolean | null | undefined;
    _ids?: Array<string | null> | null | undefined;
    _operators?: OperatorsFilterFindManyReminderInput | null | undefined;
    OR?: Array<FilterFindManyReminderInput> | null | undefined;
    AND?: Array<FilterFindManyReminderInput> | null | undefined;
};
export type ReminderExternalIdInput = {
    source?: EnumReminderExternalIdSource | null | undefined;
    value?: string | null | undefined;
    _id?: string | null | undefined;
};
export type OperatorsFilterFindManyReminderInput = {
    user?: UserOperatorsFilterFindManyReminderInput | null | undefined;
    _id?: _idOperatorsFilterFindManyReminderInput | null | undefined;
    deleted?: DeletedOperatorsFilterFindManyReminderInput | null | undefined;
    createdAt?: CreatedAtOperatorsFilterFindManyReminderInput | null | undefined;
    updatedAt?: UpdatedAtOperatorsFilterFindManyReminderInput | null | undefined;
    createdBy?: CreatedByOperatorsFilterFindManyReminderInput | null | undefined;
    updatedBy?: UpdatedByOperatorsFilterFindManyReminderInput | null | undefined;
    deletedBy?: DeletedByOperatorsFilterFindManyReminderInput | null | undefined;
    deletedAt?: DeletedAtOperatorsFilterFindManyReminderInput | null | undefined;
    provider?: ProviderOperatorsFilterFindManyReminderInput | null | undefined;
    appointment?: AppointmentOperatorsFilterFindManyReminderInput | null | undefined;
    referral?: ReferralOperatorsFilterFindManyReminderInput | null | undefined;
    recall?: RecallOperatorsFilterFindManyReminderInput | null | undefined;
    telehealth?: TelehealthOperatorsFilterFindManyReminderInput | null | undefined;
    followup?: FollowupOperatorsFilterFindManyReminderInput | null | undefined;
    followupOperation?: FollowupOperationOperatorsFilterFindManyReminderInput | null | undefined;
    facility?: FacilityOperatorsFilterFindManyReminderInput | null | undefined;
    patient?: PatientOperatorsFilterFindManyReminderInput | null | undefined;
    patientForm?: PatientFormOperatorsFilterFindManyReminderInput | null | undefined;
    message?: MessageOperatorsFilterFindManyReminderInput | null | undefined;
    type?: TypeOperatorsFilterFindManyReminderInput | null | undefined;
    externalId?: ExternalIdOperatorsFilterFindManyReminderInput | null | undefined;
    sendAt?: SendAtOperatorsFilterFindManyReminderInput | null | undefined;
    sentAt?: SentAtOperatorsFilterFindManyReminderInput | null | undefined;
    contact?: ContactOperatorsFilterFindManyReminderInput | null | undefined;
    messageTemplate?: MessageTemplateOperatorsFilterFindManyReminderInput | null | undefined;
    status?: StatusOperatorsFilterFindManyReminderInput | null | undefined;
    statusUpdatedAt?: StatusUpdatedAtOperatorsFilterFindManyReminderInput | null | undefined;
    statusReason?: StatusReasonOperatorsFilterFindManyReminderInput | null | undefined;
    replied?: RepliedOperatorsFilterFindManyReminderInput | null | undefined;
    repliedMessage?: RepliedMessageOperatorsFilterFindManyReminderInput | null | undefined;
    originalRepliedMessage?: OriginalRepliedMessageOperatorsFilterFindManyReminderInput | null | undefined;
    repliedTime?: RepliedTimeOperatorsFilterFindManyReminderInput | null | undefined;
    partialStatus?: PartialStatusOperatorsFilterFindManyReminderInput | null | undefined;
    forcedTime?: ForcedTimeOperatorsFilterFindManyReminderInput | null | undefined;
};
export type UserOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type _idOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedOperatorsFilterFindManyReminderInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type CreatedAtOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type UpdatedAtOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type CreatedByOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type UpdatedByOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedByOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type DeletedAtOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type ProviderOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type AppointmentOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type ReferralOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type RecallOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type TelehealthOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FollowupOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type FollowupOperationOperatorsFilterFindManyReminderInput = {
    gt?: EnumReminderFollowupOperation | null | undefined;
    gte?: EnumReminderFollowupOperation | null | undefined;
    lt?: EnumReminderFollowupOperation | null | undefined;
    lte?: EnumReminderFollowupOperation | null | undefined;
    ne?: EnumReminderFollowupOperation | null | undefined;
    in?: Array<EnumReminderFollowupOperation | null> | null | undefined;
    nin?: Array<EnumReminderFollowupOperation | null> | null | undefined;
    regex?: EnumReminderFollowupOperation | null | undefined;
};
export type FacilityOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PatientOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type PatientFormOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type MessageOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type TypeOperatorsFilterFindManyReminderInput = {
    gt?: EnumReminderType | null | undefined;
    gte?: EnumReminderType | null | undefined;
    lt?: EnumReminderType | null | undefined;
    lte?: EnumReminderType | null | undefined;
    ne?: EnumReminderType | null | undefined;
    in?: Array<EnumReminderType | null> | null | undefined;
    nin?: Array<EnumReminderType | null> | null | undefined;
    regex?: EnumReminderType | null | undefined;
};
export type ExternalIdOperatorsFilterFindManyReminderInput = {
    gt?: ReminderExternalIdInput | null | undefined;
    gte?: ReminderExternalIdInput | null | undefined;
    lt?: ReminderExternalIdInput | null | undefined;
    lte?: ReminderExternalIdInput | null | undefined;
    ne?: ReminderExternalIdInput | null | undefined;
    in?: Array<ReminderExternalIdInput | null> | null | undefined;
    nin?: Array<ReminderExternalIdInput | null> | null | undefined;
    regex?: ReminderExternalIdInput | null | undefined;
};
export type SendAtOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type SentAtOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type ContactOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type MessageTemplateOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type StatusOperatorsFilterFindManyReminderInput = {
    gt?: EnumReminderStatus | null | undefined;
    gte?: EnumReminderStatus | null | undefined;
    lt?: EnumReminderStatus | null | undefined;
    lte?: EnumReminderStatus | null | undefined;
    ne?: EnumReminderStatus | null | undefined;
    in?: Array<EnumReminderStatus | null> | null | undefined;
    nin?: Array<EnumReminderStatus | null> | null | undefined;
    regex?: EnumReminderStatus | null | undefined;
};
export type StatusUpdatedAtOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type StatusReasonOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type RepliedOperatorsFilterFindManyReminderInput = {
    gt?: number | null | undefined;
    gte?: number | null | undefined;
    lt?: number | null | undefined;
    lte?: number | null | undefined;
    ne?: number | null | undefined;
    in?: Array<number | null> | null | undefined;
    nin?: Array<number | null> | null | undefined;
    regex?: number | null | undefined;
};
export type RepliedMessageOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type OriginalRepliedMessageOperatorsFilterFindManyReminderInput = {
    gt?: string | null | undefined;
    gte?: string | null | undefined;
    lt?: string | null | undefined;
    lte?: string | null | undefined;
    ne?: string | null | undefined;
    in?: Array<string | null> | null | undefined;
    nin?: Array<string | null> | null | undefined;
    regex?: string | null | undefined;
};
export type RepliedTimeOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type PartialStatusOperatorsFilterFindManyReminderInput = {
    gt?: unknown | null | undefined;
    gte?: unknown | null | undefined;
    lt?: unknown | null | undefined;
    lte?: unknown | null | undefined;
    ne?: unknown | null | undefined;
    in?: Array<unknown | null> | null | undefined;
    nin?: Array<unknown | null> | null | undefined;
    regex?: unknown | null | undefined;
};
export type ForcedTimeOperatorsFilterFindManyReminderInput = {
    gt?: boolean | null | undefined;
    gte?: boolean | null | undefined;
    lt?: boolean | null | undefined;
    lte?: boolean | null | undefined;
    ne?: boolean | null | undefined;
    in?: Array<boolean | null> | null | undefined;
    nin?: Array<boolean | null> | null | undefined;
    regex?: boolean | null | undefined;
};
export type TableReminders_refetchableVariables = {
    count?: number | null | undefined;
    cursor?: string | null | undefined;
    filter?: FilterFindManyReminderInput | null | undefined;
};
export type TableReminders_refetchableResponse = {
    readonly " $fragmentRefs": FragmentRefs<"TableReminders_Query">;
};
export type TableReminders_refetchable = {
    readonly response: TableReminders_refetchableResponse;
    readonly variables: TableReminders_refetchableVariables;
};



/*
query TableReminders_refetchable(
  $count: Int = 15
  $cursor: String
  $filter: FilterFindManyReminderInput
) {
  ...TableReminders_Query_3KQYpM
}

fragment IconButtonReminderActions_Reminder on Reminder {
  _id
  sendAt
  patient {
    _id
    id
  }
  oid_appointment
}

fragment TableReminders_Query_3KQYpM on Query {
  reminderConnection(first: $count, after: $cursor, sort: SENDAT_ASC, filter: $filter) {
    edges {
      node {
        _id
        oid_facility
        ...TableRowReminder_Reminder
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment TableRowReminder_Reminder on Reminder {
  _id
  sendAt
  patient {
    _id
    name
    contact {
      active
      type
      value
    }
    doNotContact
    id
  }
  appointment {
    date
    provider {
      name
      id
    }
    id
  }
  ...TypographyReminderType_Reminder
  ...IconButtonReminderActions_Reminder
}

fragment TypographyReminderType_Reminder on Reminder {
  type
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 15,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v2 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "SENDAT_ASC"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TableReminders_refetchable",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "count",
            "variableName": "count"
          },
          {
            "kind": "Variable",
            "name": "cursor",
            "variableName": "cursor"
          },
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "TableReminders_Query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TableReminders_refetchable",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "ReminderConnection",
        "kind": "LinkedField",
        "name": "reminderConnection",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ReminderEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Reminder",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oid_facility",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "sendAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Patient",
                    "kind": "LinkedField",
                    "name": "patient",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PatientContact",
                        "kind": "LinkedField",
                        "name": "contact",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "active",
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "doNotContact",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "appointment",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "date",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Provider",
                        "kind": "LinkedField",
                        "name": "provider",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "oid_appointment",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": [
          "sort",
          "filter"
        ],
        "handle": "connection",
        "key": "TableReminders_reminderConnection",
        "kind": "LinkedHandle",
        "name": "reminderConnection"
      }
    ]
  },
  "params": {
    "cacheID": "ac9e0f62742caed80fc9b72ebbb191c8",
    "id": null,
    "metadata": {},
    "name": "TableReminders_refetchable",
    "operationKind": "query",
    "text": "query TableReminders_refetchable(\n  $count: Int = 15\n  $cursor: String\n  $filter: FilterFindManyReminderInput\n) {\n  ...TableReminders_Query_3KQYpM\n}\n\nfragment IconButtonReminderActions_Reminder on Reminder {\n  _id\n  sendAt\n  patient {\n    _id\n    id\n  }\n  oid_appointment\n}\n\nfragment TableReminders_Query_3KQYpM on Query {\n  reminderConnection(first: $count, after: $cursor, sort: SENDAT_ASC, filter: $filter) {\n    edges {\n      node {\n        _id\n        oid_facility\n        ...TableRowReminder_Reminder\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TableRowReminder_Reminder on Reminder {\n  _id\n  sendAt\n  patient {\n    _id\n    name\n    contact {\n      active\n      type\n      value\n    }\n    doNotContact\n    id\n  }\n  appointment {\n    date\n    provider {\n      name\n      id\n    }\n    id\n  }\n  ...TypographyReminderType_Reminder\n  ...IconButtonReminderActions_Reminder\n}\n\nfragment TypographyReminderType_Reminder on Reminder {\n  type\n}\n"
  }
};
})();
(node as any).hash = 'b9ccfc5eac2286e65f30ac448aea01e1';
export default node;
